var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWandStars(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.39-140.41 140-175.8l317.54-317.48-177-43.75 179.9-111.89L445-860l161.8 136.1 195.69-79.18-79 195.9L860-445.59l-211.74-15.26-111.44 179.64-43.87-176.74-317.56 317.54Zm24.02-535.75L140-735.56l59.82-59.82 59.67 59.4-60.08 59.82ZM556.9-408.41l64.66-104.46 122.67 8.97-79.69-94.23 46.03-113.44-113.44 46.03-94.23-79.49 8.97 122.47-104.08 65.28 119.29 29.61 29.82 119.26ZM735.98-140l-59.41-59.82 59.41-59.67 59.4 60.08-59.4 59.41ZM576.54-577.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandStars);
export default __webpack_public_path__ + "static/media/wand-stars.3773208bee590bb7e0540093ad30b88f.svg";
export { ForwardRef as ReactComponent };